import React, { Component, Fragment } from 'react'

import ColorPicker from 'components/Settings/ColorPicker'
import Image from 'components/Image'

import * as selectors from 'modules/settings/selectors'
import { connect } from 'react-redux'
import * as actions from 'modules/settings/actions'
import { bindActionCreators } from 'redux'

import './style.css'

class LookAndFeelSettings extends Component {
  
  handleLogoUpload = url => this.props.setLogo(url)
  
  handleFaviconUpload = url => this.props.setFavicon(url)
  
  render() {
    const { settings } = this.props
    return (
      <div className="basic-settings-wrapper">
        <ColorPicker/>
        <Image
          onUpload={this.handleLogoUpload}
          url={settings.logo}
          backgroundColor={settings.mainColor}
          imageClassName="image-preview-image--logo"
          description={
            <Fragment>
              <p>Your logo will be used in the header of your help center</p>
              <p>It should be 150px wide and a JPG or PNG</p>
            </Fragment>
          }
        />
  
        <Image
          onUpload={this.handleFaviconUpload}
          url={settings.favicon}
          imageClassName="image-preview-image--favicon"
          description={
            <Fragment>
              <p>Your favicon will be displayed in the address bar of your browser</p>
              <p>It should be a PNG at 32x32px</p>
            </Fragment>
          }
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  settings: selectors.getSettings(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setLogo: actions.setLogo,
    setFavicon: actions.setFavicon
  }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(LookAndFeelSettings)